var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.235.281l-.36.375c-.523.575-.771 1.303-.828 2.031L6.015 4.72c-1.234-.22-2.563.126-3.514 1.078l-.36.36.36.343 2.156 2.156L.5 12.796v.704h.703l4.141-4.157 2.109 2.11.344.36.359-.36c1.048-1.048 1.345-2.487 1.031-3.78L10.97 5.89c.869.104 1.757-.146 2.39-.78l.344-.36-.343-.36L9.61.64 9.235.282zm.109 1.531l2.844 2.844c-.413.233-.859.38-1.313.265l-.281-.077-.204.203L8.297 7.14l-.219.22.095.297a2.988 2.988 0 01-.423 2.687L3.656 6.25c.727-.5 1.603-.73 2.422-.515l.265.077.204-.203L8.86 3.296l.14-.14v-.204c0-.401.146-.781.344-1.14z"
  })));
}
export default SvgPinIcon;